// extracted by mini-css-extract-plugin
export default {"table":"GridTable_table__vRoC0","box":"GridTable_box__FGQC2"};